line<template>

  <div>

    <b-breadcrumb :items="$options.breadcrumb"/>

    <div class="d-flex align-items-center justify-content-between">
      <h2>Printer profielen</h2>
      <b-btn variant="success" to="/main/config/profiles/create">
        <span class="mdi mdi-plus-thick"> Profiel toevoegen</span>
      </b-btn>
    </div>

    <b-table :items="profiles.nodes" :fields="$options.fields" small hover>
      <template v-slot:cell(actions)="row">
        <b-btn size="sm" variant="danger" @click="deleteProfile(row)"><span class="mdi mdi-delete"> Verwijderen</span></b-btn>
        <b-btn size="sm" variant="success" class="ml-1" :to="`/main/config/profiles/create/from/${row.item.id}`"><span class="mdi mdi-content-copy"> Kopiëer als nieuw</span></b-btn>
        <b-btn size="sm" variant="primary" class="ml-1" :to="`/main/config/profiles/edit/${row.item.id}`"><span class="mdi mdi-pencil"> Bewerken</span></b-btn>
      </template>
    </b-table>
  </div>


</template>

<script>

import {CACHE_AND_NETWORK} from '../../lib/constants';
import actionField from '../../lib/actionField';

export default
{
    apollo:
    {
        profiles:
        {
            query: require('../../graphql/listProfiles.query.gql'),
            fetchPolicy: CACHE_AND_NETWORK
        }
    },
    data()
    {
        return {
            profiles: { nodes: [] }
        }
    },
    methods:
    {
        async deleteProfile(row)
        {
            const response = await this.$bvModal.msgBoxConfirm('Ben je zeker dat je dit wil verwijderen?',
                {
                    title: 'Profiel verwijderen',
                    okTitle: 'Verwijder',
                    okVariant: 'danger',
                    centered: true,
                    cancelTitle: 'Niet verwijderen',
                    cancelVariant: 'info'
                }
            );

            if(!response)
                return;

            await this.$apollo.mutate(
                {
                    mutation: require('../../graphql/deleteProfile.mutation.gql'),
                    variables: { id: row.item.id }
                }
            );

            await this.$apollo.queries.profiles.refetch();
        }
    },
    breadcrumb:
    [
        {text: 'Configuratie'},
        {text: 'Printer profielen'}
    ],
    fields:
    [
        {
            key: 'name',
            label: 'Naam'
        },
        actionField
    ]
}
</script>

<style>
</style>